export const gameTypeOptions =[
    {text:"Private",value:"416b6b95-5d42-4b6c-8711-0fd8e8bdee87"},
    {text:"Public",value:"958a15e1-7ac7-444e-8292-ea1eeb4f85ba"}
]

export const createGameTypeOptions = (t: any) => [
    { text: t('gameTypes.private'), value: "416b6b95-5d42-4b6c-8711-0fd8e8bdee87" },
    { text: t('gameTypes.public'), value: "958a15e1-7ac7-444e-8292-ea1eeb4f85ba" }
];